<template>
    <AccordionBasic
        title="campaign_marketing_risk_disclaimer"
        class="mb-2"
        :open="false"
    >
        <EditorField
            v-model="campaign.risk_disclaimer"
            name="risk_disclaimer"
            label="campaign_marketing_risk_disclaimer"
            help="help_campaign_marketing_risk_disclaimer"
            variant="minimal"
        />
    </AccordionBasic>
    <AccordionBasic
        title="campaign_marketing_asset_information"
        class="mb-2"
        :open="false"
    >
        <RepeatableFieldGroup
            v-model="campaign.asset_information"
            name-prefix="asset_information"
            :fields="assetInformationFields"
            :columns="2"
        />
    </AccordionBasic>
    <AccordionBasic
        title="campaign_marketing_media"
        class="mb-2"
        :open="false"
    >
        <ImageUpload
            v-model="campaign.thumb_image"
            name="campaign_thumb_image_marketing"
            label="campaign_thumb_image"
            help="help_campaign_thumb_image"
            type="campaign"
        />
        <TextField
            v-model="campaign.asset_video"
            label="asset_video"
            name="asset_video_marketing"
            :required="false"
            help="help_asset_video"
        />
    </AccordionBasic>
    <AccordionBasic
        title="campaign_marketing_overview"
        class="mb-2"
        :open="false"
    >
        <AccordionBasic
            title="campaign_marketing_company_presentation"
            class="mb-2"
            :open="false"
            :lazy="true"
        >
            <EditorField
                v-model="campaign.company_overview"
                name="company_overview"
                label="campaign_marketing_company_presentation"
                help="help_campaign_marketing_company_presentation"
                variant="minimal"
            />
        </AccordionBasic>
        <AccordionBasic
            title="campaign_marketing_key_facts"
            class="mb-2"
            :open="false"
            :lazy="true"
        >
            <RepeatableFieldGroup
                v-model="campaign.company_key_facts"
                name-prefix="company_key_facts"
                :fields="keyFactFields"
            />
            <TextField
                v-model="campaign.company_key_facts_note"
                name="company_key_facts_note"
                label="campaign_marketing_key_facts_note"
                help="help_campaign_marketing_key_facts_note"
            />
        </AccordionBasic>
        <AccordionBasic
            title="campaign_marketing_white_label_box"
            class="mb-2"
            :open="false"
            :lazy="true"
        >
            <TextField
                v-model="campaign.white_label_box_title"
                name="white_label_box_title"
                label="campaign_marketing_white_label_box_title"
                help="help_campaign_marketing_white_label_box_title"
            />
            <TextField
                v-model="campaign.white_label_box_icon"
                name="white_label_box_icon"
                label="campaign_marketing_white_label_box_icon"
                help="help_campaign_marketing_white_label_box_icon"
            />
            <EditorField
                v-model="campaign.white_label_box_description"
                name="white_label_box_description"
                label="campaign_marketing_white_label_box_description"
                help="help_campaign_marketing_white_label_box_description"
                variant="minimal"
            />
        </AccordionBasic>
        <AccordionBasic
            title="campaign_marketing_milestones"
            class="mb-2"
            :open="false"
            :lazy="true"
        >
            <RepeatableFieldGroup
                v-model="campaign.company_milestones"
                name-prefix="company_milestones"
                :fields="milestoneFields"
            />
        </AccordionBasic>
        <AccordionBasic
            title="campaign_marketing_team"
            class="mb-2"
            :open="false"
            :lazy="true"
        >
            <EditorField
                v-model="campaign.company_team_overview"
                name="company_team_overview"
                label="campaign_marketing_team"
                help="help_campaign_marketing_team"
                variant="minimal"
            />
            <slot name="team_members" />
        </AccordionBasic>
        <AccordionBasic
            title="campaign_marketing_podcast"
            class="mb-2"
            :open="false"
        >
            <SelectField
                v-model="campaign.podcast_id"
                name="podcast_id"
                label="campaign_marketing_podcast"
                help="help_campaign_marketing_podcast"
                :options="
                    podcasts.map((podcast) => ({
                        label: podcast.title,
                        value: podcast.id,
                    }))
                "
            />
        </AccordionBasic>
        <AccordionBasic
            title="campaign_marketing_community"
            class="mb-2"
            :open="false"
        >
            <TextField
                v-model="campaign.community_link"
                name="community_link"
                label="campaign_marketing_community"
                help="help_campaign_marketing_community"
            />
        </AccordionBasic>
        <AccordionBasic
            title="campaign_marketing_incentives"
            class="mb-2"
            :open="false"
        >
            <slot name="incentives" />
        </AccordionBasic>
    </AccordionBasic>
    <AccordionBasic
        title="campaign_marketing_details"
        class="mb-2"
        :open="false"
    >
        <AccordionBasic
            title="campaign_marketing_business_model"
            class="mb-2"
            :open="false"
        >
            <AccordionBasic
                title="campaign_marketing_business_model_section"
                class="mb-2"
                :open="false"
                :lazy="true"
            >
                <EditorField
                    v-model="campaign.business_model"
                    name="business_model"
                    label="campaign_marketing_business_model_section"
                    help="help_campaign_marketing_business_model_section"
                    variant="minimal"
                />
            </AccordionBasic>
            <AccordionBasic
                title="campaign_marketing_offerings"
                class="mb-2"
                :open="false"
                :lazy="true"
            >
                <RepeatableFieldGroup
                    v-model="campaign.offerings"
                    name-prefix="offerings"
                    :fields="offeringsFields"
                />
            </AccordionBasic>
            <AccordionBasic
                title="campaign_marketing_revenue_structure"
                class="mb-2"
                :open="false"
                :lazy="true"
            >
                <RepeatableFieldGroup
                    v-model="campaign.revenue_structure"
                    name-prefix="revenue_structure"
                    :fields="revenueStructureFields"
                />
            </AccordionBasic>
            <AccordionBasic
                title="campaign_marketing_competitive_advantages"
                class="mb-2"
                :open="false"
                :lazy="true"
            >
                <RepeatableFieldGroup
                    v-model="campaign.competitive_advantages"
                    name-prefix="competitive_advantages"
                    :fields="competitiveAdvantagesFields"
                />
            </AccordionBasic>
        </AccordionBasic>
        <AccordionBasic
            title="campaign_marketing_market_potential"
            class="mb-2"
            :open="false"
        >
            <AccordionBasic
                title="campaign_marketing_market_segment"
                class="mb-2"
                :open="false"
                :lazy="true"
            >
                <EditorField
                    v-model="campaign.market_segment"
                    name="market_segment"
                    label="campaign_marketing_market_segment"
                    help="help_campaign_marketing_market_segment"
                    variant="minimal"
                />
            </AccordionBasic>
            <AccordionBasic
                title="campaign_marketing_trends"
                class="mb-2"
                :open="false"
                :lazy="true"
            >
                <RepeatableFieldGroup
                    v-model="campaign.trends"
                    name-prefix="trends"
                    :fields="trendsFields"
                />
            </AccordionBasic>
            <AccordionBasic
                title="campaign_marketing_competition"
                class="mb-2"
                :open="false"
                :lazy="true"
            >
                <EditorField
                    v-model="campaign.competition"
                    name="competition"
                    label="campaign_marketing_competition"
                    help="help_campaign_marketing_competition"
                    variant="minimal"
                />
            </AccordionBasic>
            <AccordionBasic
                title="campaign_marketing_swot_analysis"
                class="mb-2"
                :open="false"
                :lazy="true"
            >
                <RepeatableFieldGroup
                    v-model="campaign.swot_analysis"
                    name-prefix="swot_analysis"
                    :fields="swotAnalysisFields"
                />
            </AccordionBasic>
        </AccordionBasic>
        <AccordionBasic
            title="campaign_marketing_financials_projections"
            class="mb-2"
            :open="false"
        >
            <AccordionBasic
                title="campaign_marketing_past_financial_figures"
                class="mb-2"
                :open="false"
                :lazy="true"
            >
                <CampaignContentFinancialsBlock
                    v-model:introduction="
                        campaign.past_financial_data_introduction
                    "
                    v-model:tables="campaign.past_financial_tables"
                    name-prefix="past_financial_tables"
                />
            </AccordionBasic>
            <AccordionBasic
                title="campaign_marketing_current_status"
                class="mb-2"
                :open="false"
                :lazy="true"
            >
                <EditorField
                    v-model="campaign.current_status"
                    name="current_status"
                    label="campaign_marketing_current_status"
                    help="help_campaign_marketing_current_status"
                    variant="minimal"
                />
                <CampaignCurrentStatusBoxes
                    v-model="campaign.current_status_boxes"
                    name-prefix="current_status_boxes"
                />
            </AccordionBasic>
            <AccordionBasic
                title="campaign_marketing_projections_strategy"
                class="mb-2"
                :open="false"
                :lazy="true"
            >
                <CampaignContentFinancialsBlock
                    v-model:introduction="
                        campaign.projected_financial_data_introduction
                    "
                    v-model:tables="campaign.projected_financial_tables"
                    name-prefix="projected_financial_tables"
                />
            </AccordionBasic>
        </AccordionBasic>
        <AccordionBasic
            title="campaign_marketing_use_of_funds"
            class="mb-2"
            :open="false"
            :lazy="true"
        >
            <CampaignContentBlockUseOfFunds
                v-model:description="campaign.use_of_funds_description"
                v-model:total="campaign.use_of_funds_total"
                v-model:threshold="campaign.use_of_funds_threshold"
                v-model:fully-funded="campaign.use_of_funds_fully_funded"
                v-model:items="campaign.use_of_funds_items"
            />
        </AccordionBasic>
        <AccordionBasic
            title="campaign_marketing_sustainability"
            class="mb-2"
            :open="false"
            :lazy="true"
        >
            <CampaignContentBlockSustainability
                v-model:score="campaign.esg_score"
                v-model:description="campaign.esg_description"
                v-model:cards="campaign.esg_cards"
                v-model:sdgs="campaign.esg_sdgs"
                v-model:document="campaign.esg_document"
            />
        </AccordionBasic>
    </AccordionBasic>
    <AccordionBasic
        title="campaign_marketing_news"
        class="mb-2"
        :open="false"
    >
        <SelectField
            v-model="campaign.news"
            name="news"
            label="campaign_marketing_news"
            help="help_campaign_marketing_news"
            :multiple="true"
            :options="
                news.map((newsItem) => ({
                    label: newsItem.title,
                    value: newsItem.id,
                }))
            "
        />
    </AccordionBasic>
</template>

<script setup lang="ts">
import AccordionBasic from '@src/components/AccordionBasic.vue'
import EditorField from '@src/components/EditorField.vue'
import ImageUpload from '@src/components/ImageUpload.vue'
import NumberField from '@src/components/NumberField.vue'
import RepeatableFieldGroup, {
    type RepeatableFieldSchema,
} from '@src/components/RepeatableFieldGroup.vue'
import SelectField from '@src/components/SelectField.vue'
import TextField from '@src/components/TextField.vue'
import { BlogPostType } from '@src/enums'
import { Blog, Campaign, Podcast } from '@src/types'
import { getBlogPosts } from '@src/utils/api/blogPosts'
import { useVModel } from '@vueuse/core'
import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import CampaignContentFinancialsBlock from './CampaignContentFinancialsBlock.vue'
import CampaignCurrentStatusBoxes from './CampaignCurrentStatusBoxes.vue'
import CampaignContentBlockSustainability from './CampaignContentBlockSustainability.vue'
import CampaignContentBlockUseOfFunds from './CampaignContentBlockUseOfFunds.vue'

const props = defineProps<{
    campaign: Campaign
}>()

const emit = defineEmits<{
    (e: 'update:campaign', value: Campaign): void
}>()

const campaign = useVModel(props, 'campaign', emit)
const { t } = useI18n()

const podcasts = ref<Podcast[]>([])
const news = ref<Blog[]>([])

const assetInformationFields: RepeatableFieldSchema[] = [
    {
        key: 'label',
        component: TextField,
        label: 'campaign_marketing_asset_information_label',
        help: 'help_campaign_marketing_asset_information_label',
        default: '',
    },
    {
        key: 'value',
        component: TextField,
        label: 'campaign_marketing_asset_information_value',
        help: 'help_campaign_marketing_asset_information_value',
        default: '',
    },
]

const keyFactFields: RepeatableFieldSchema[] = [
    {
        key: 'label',
        component: TextField,
        label: 'campaign_marketing_key_fact_label',
        help: 'help_campaign_marketing_key_fact_label',
        default: '',
    },
    {
        key: 'value',
        component: EditorField,
        label: 'campaign_marketing_key_fact_value',
        help: 'help_campaign_marketing_key_fact_value',
        default: '',
        props: { variant: 'minimal' },
    },
]

const milestoneFields: RepeatableFieldSchema[] = [
    {
        key: 'label',
        component: TextField,
        label: 'campaign_marketing_milestone_label',
        help: 'help_campaign_marketing_milestone_label',
        default: '',
    },
    {
        key: 'value',
        component: EditorField,
        label: 'campaign_marketing_milestone_value',
        help: 'help_campaign_marketing_milestone_value',
        default: '',
        props: { variant: 'minimal' },
    },
]

const offeringsFields: RepeatableFieldSchema[] = [
    {
        key: 'title',
        component: TextField,
        label: 'campaign_marketing_offering_title',
        help: 'help_campaign_marketing_offering_title',
        default: '',
    },
    {
        key: 'description',
        component: EditorField,
        label: 'campaign_marketing_offering_description',
        help: 'help_campaign_marketing_offering_description',
        default: '',
        props: { variant: 'minimal' },
    },
]

const revenueStructureFields: RepeatableFieldSchema[] = [
    {
        key: 'title',
        component: TextField,
        label: 'campaign_marketing_revenue_structure_title',
        help: 'help_campaign_marketing_revenue_structure_title',
        default: '',
    },
    {
        key: 'description',
        component: EditorField,
        label: 'campaign_marketing_revenue_structure_description',
        help: 'help_campaign_marketing_revenue_structure_description',
        default: '',
        props: { variant: 'minimal' },
    },
    {
        key: 'percentage',
        component: NumberField,
        label: 'campaign_marketing_revenue_structure_percentage',
        help: 'help_campaign_marketing_revenue_structure_percentage',
        default: null,
        props: { unit: '%', min: 0, max: 100 },
    },
]

const competitiveAdvantagesFields: RepeatableFieldSchema[] = [
    {
        key: 'title',
        component: TextField,
        label: 'campaign_marketing_competitive_advantage_title',
        help: 'help_campaign_marketing_competitive_advantage_title',
        default: '',
    },
    {
        key: 'description',
        component: EditorField,
        label: 'campaign_marketing_competitive_advantage_description',
        help: 'help_campaign_marketing_competitive_advantage_description',
        default: '',
        props: { variant: 'minimal' },
    },
]

const trendsFields: RepeatableFieldSchema[] = [
    {
        key: 'title',
        component: TextField,
        label: 'campaign_marketing_trend_title',
        help: 'help_campaign_marketing_trend_title',
        default: '',
    },
    {
        key: 'description',
        component: EditorField,
        label: 'campaign_marketing_trend_description',
        help: 'help_campaign_marketing_trend_description',
        default: '',
        props: { variant: 'minimal' },
    },
]

const swotAnalysisFields = computed<RepeatableFieldSchema[]>(() => [
    {
        key: 'title',
        component: TextField,
        label: 'campaign_marketing_swot_title',
        help: 'help_campaign_marketing_swot_title',
        default: '',
    },
    {
        key: 'description',
        component: EditorField,
        label: 'campaign_marketing_swot_description',
        help: 'help_campaign_marketing_swot_description',
        default: '',
        props: { variant: 'minimal' },
    },
    {
        key: 'type',
        component: SelectField,
        label: 'campaign_marketing_swot_type',
        help: 'help_campaign_marketing_swot_type',
        default: null,
        props: {
            options: [
                {
                    label: t('campaign_marketing_swot_type_success'),
                    value: 'success',
                },
                {
                    label: t('campaign_marketing_swot_type_error'),
                    value: 'error',
                },
            ],
        },
    },
])

const fetchPodcasts = async () => {
    if (
        !campaign.value.platform_name ||
        !campaign.value.language ||
        podcasts.value.length > 0
    )
        return
    const response = await getBlogPosts(
        campaign.value.platform_name,
        BlogPostType.PODCAST,
        campaign.value.language
    )
    podcasts.value = response.data as Podcast[]
}

const fetchNews = async () => {
    if (
        !campaign.value.platform_name ||
        !campaign.value.language ||
        news.value.length > 0
    )
        return
    const response = await getBlogPosts(
        campaign.value.platform_name,
        BlogPostType.BLOG,
        campaign.value.language
    )
    news.value = response.data as Blog[]
}

watch(
    () => [campaign.value.platform_name, campaign.value.language],
    async () => {
        await fetchPodcasts()
        await fetchNews()
    }
)
</script>
